var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sfjs-iframe-container"},[_c('iframe',{attrs:{"src":_vm.iframeSrc,"width":"100%","height":"100%","frameborder":"0","scrolling":"auto"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }